import {Component, Input, OnChanges, OnInit, SimpleChanges, signal} from '@angular/core';
import {Task} from '@core/types';
import moment, {Moment} from 'moment-timezone';

@Component({
  selector: 'core-task-gantt',
  standalone: true,
  imports: [],
  templateUrl: './task-gantt.html'
})
export class TaskGantt implements OnInit, OnChanges  {
  @Input() tasks: Task[] = [];
  @Input() startDate: Moment = moment();
  @Input() endDate: Moment = moment();
  @Input() tickSpan = 2;
  @Input() timeSpan = 1;

  days = signal<Moment[]>([]);

  ngOnInit() {
    this.generateDays();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['startDate'] || changes['endDate']) {
      this.generateDays();
    }
  }

  getStartColumn(taskStart: Moment): number {
    const diffDays = taskStart.diff(this.startDate, 'days');
    return Math.floor(diffDays / this.timeSpan) + 1;
  }

  getDurationDays(start: Moment, end: Moment): number {
    const diffDays = end.diff(start, 'days') + 1;
    return Math.ceil(diffDays / this.timeSpan);
  }

  getTaskRow(index: number): number {
    return index + 2;
  }

  getTaskBackground(priority?: string): string {
    switch (priority) {
      case 'high':
        return 'var(--color-red-200)';
      case 'low':
        return 'var(--color-primary-200)';
      case 'medium':
      default:
        return 'var(--color-yellow-200)';
    }
  }

  private generateDays() {
    const dates: Moment[] = [];
    let current = this.startDate.clone();
    while (current <= this.endDate) {
      dates.push(current.clone());
      current.add(this.timeSpan, 'day');
    }
    this.days.set(dates);
  }
}
